import { Dispatch, SetStateAction } from 'react'
import { Filter, SearchProductsResponse } from 'src/services/linx-api/dtos'
import { FilterProduct } from 'src/templates/SearchAndCategory'

export type IdentifyFilterProps = {
  setArrayFilters: Dispatch<SetStateAction<Partial<FilterProduct>[]>>
  setSelectedFilter: Dispatch<SetStateAction<Partial<FilterProduct>>>
  URLFilter: string[]
  filters: Filter[]
  results: SearchProductsResponse
}

export const identifyFilter = ({
  setArrayFilters,
  setSelectedFilter,
  URLFilter,
  filters,
  results,
}: IdentifyFilterProps) => {
  const filtrosArray: Partial<FilterProduct>[] = []
  let arrayFiltrosCompleto: any[] = []

  if (!URLFilter) {
    setSelectedFilter({
      tipo: '',
      id_atributo: '',
      id_valor_unidade: '',
      valor_minimo: null,
      valor_maximo: null,
      descricao: '',
      label: '',
    })

    return setArrayFilters([])
  }

  URLFilter.map((filtro) => {
    const splitFiltro = filtro.split(':')

    const index = filtrosArray.findIndex(
      (f) =>
        f.tipo === (splitFiltro[0] == 'c' ? 'continuous' : 'discrete') &&
        f.id_atributo === splitFiltro[1] &&
        f.id_valor_unidade === splitFiltro[2]
    )

    if (index !== -1) {
      filtrosArray[index].valor_minimo =
        splitFiltro[0] == 'd' ? null : splitFiltro[3]
      filtrosArray[index].valor_maximo =
        splitFiltro[0] == 'd' ? null : splitFiltro[4]

      return
    }

    filtrosArray.push({
      tipo: splitFiltro[0] == 'c' ? 'continuous' : 'discrete',
      id_atributo: splitFiltro[1],
      id_valor_unidade: splitFiltro[2],
      valor_minimo: splitFiltro[0] == 'd' ? null : splitFiltro[3],
      valor_maximo: splitFiltro[0] == 'd' ? null : splitFiltro[4],
      descricao: '',
      label: '',
      queryFiltro: `filtro=${filtro}`,
    })
  })

  if (filters) {
    filtrosArray.map((filtroArray) => {
      const filtroAtributos = filters.find(
        (filtro) =>
          filtro.type == filtroArray.tipo &&
          filtro.id == filtroArray.id_atributo
      )

      if (filtroAtributos) {
        const filtroAtivo = filtroAtributos.values.find((filtro) => {
          if (filtro.id) return filtro.id == filtroArray.id_valor_unidade

          return filtro.unityId == filtroArray.id_valor_unidade
        })

        if (filtroAtivo) {
          arrayFiltrosCompleto.push({
            ...filtroArray,
            tipo: filtroAtributos.type,
            id_atributo: filtroAtributos.id,
            id_valor_unidade: filtroAtivo.id
              ? filtroAtivo.id
              : filtroAtivo.unityId
              ? filtroAtivo.unityId
              : '',
            descricao: filtroAtributos.attribute,
            label: filtroAtivo.label ? filtroAtivo.label : '',
          })
        }

        return setArrayFilters(arrayFiltrosCompleto)
      }
    })
    return setArrayFilters(arrayFiltrosCompleto)
  }

  if (results && results.filters) {
    arrayFiltrosCompleto = []

    filtrosArray.map((filtroArray) => {
      const filtroAtributos = results.filters.find(
        (filtro) =>
          filtro.type == filtroArray.tipo &&
          filtro.id == filtroArray.id_atributo
      )

      if (filtroAtributos) {
        const filtroAtivo = filtroAtributos.values.find((filtro) => {
          if (filtro.id) {
            if (
              filtro.min &&
              filtro.min.value &&
              filtro.max &&
              filtro.max.value
            ) {
              return (
                filtro.id == filtroArray.id_valor_unidade &&
                filtro.min.value == Number(filtroArray.valor_minimo) &&
                filtro.max.value == Number(filtroArray.valor_maximo)
              )
            }

            return filtro.id == filtroArray.id_valor_unidade
          }

          if (filtro.min && filtro.min.value && filtro.max && filtro.max.value)
            return (
              filtro.unityId == filtroArray.id_valor_unidade &&
              filtro.min.value == Number(filtroArray.valor_minimo) &&
              filtro.max.value == Number(filtroArray.valor_maximo)
            )

          return filtro.unityId == filtroArray.id_valor_unidade
        })

        if (filtroAtivo) {
          arrayFiltrosCompleto.push({
            ...filtroArray,
            tipo: filtroAtributos.type,
            id_atributo: filtroAtributos.id,
            id_valor_unidade: filtroAtivo.id
              ? filtroAtivo.id
              : filtroAtivo.unityId
              ? filtroAtivo.unityId
              : '',
            valor_minimo:
              filtroAtivo.min && filtroAtivo.min.value
                ? filtroAtivo.min.value
                : null,
            valor_maximo:
              filtroAtivo.max && filtroAtivo.max.value
                ? filtroAtivo.max.value
                : null,
            descricao: filtroAtributos.attribute,
            label: filtroAtivo.label ? filtroAtivo.label : '',
          })
        }

        if (
          !filtroAtivo &&
          (filtroAtributos.attribute == 'Categoria' ||
            filtroAtributos.attribute == 'categoria')
        ) {
          const categoria = filtroAtributos.values.find((cat) => cat.selected)

          if (!categoria) return setArrayFilters(arrayFiltrosCompleto)

          const categoriaFilho1 = categoria.filters
            ? categoria.filters.find((cat) => cat.selected)
            : null

          if (!categoriaFilho1) {
            arrayFiltrosCompleto.push({
              ...filtroArray,
              tipo: filtroAtributos.type,
              id_atributo: filtroAtributos.id,
              id_valor_unidade: categoria.id
                ? categoria.id
                : categoria.unityId
                ? categoria.unityId
                : '',
              valor_minimo:
                categoria.min && categoria.min.value
                  ? categoria.min.value
                  : null,
              valor_maximo:
                categoria.max && categoria.max.value
                  ? categoria.max.value
                  : null,
              descricao: filtroAtributos.attribute,
              label: categoria.label ? categoria.label : '',
            })

            return setArrayFilters(arrayFiltrosCompleto)
          }

          const categoriaFilho2 = categoriaFilho1.filters
            ? categoriaFilho1.filters.find((cat) => cat.selected)
            : null

          if (!categoriaFilho2) {
            arrayFiltrosCompleto.push({
              ...filtroArray,
              tipo: filtroAtributos.type,
              id_atributo: filtroAtributos.id,
              id_valor_unidade: categoriaFilho1.id
                ? categoriaFilho1.id
                : categoriaFilho1.unityId
                ? categoriaFilho1.unityId
                : '',
              valor_minimo:
                categoriaFilho1.min && categoriaFilho1.min.value
                  ? categoriaFilho1.min.value
                  : null,
              valor_maximo:
                categoriaFilho1.max && categoriaFilho1.max.value
                  ? categoriaFilho1.max.value
                  : null,
              descricao: filtroAtributos.attribute,
              label: categoriaFilho1.label ? categoriaFilho1.label : '',
            })

            return setArrayFilters(arrayFiltrosCompleto)
          }

          const categoriaFilho3 = categoriaFilho2.filters
            ? categoriaFilho2.filters.find((cat) => cat.selected)
            : null

          if (!categoriaFilho3) {
            arrayFiltrosCompleto.push({
              ...filtroArray,
              tipo: filtroAtributos.type,
              id_atributo: filtroAtributos.id,
              id_valor_unidade: categoriaFilho2.id
                ? categoriaFilho2.id
                : categoriaFilho2.unityId
                ? categoriaFilho2.unityId
                : '',
              valor_minimo:
                categoriaFilho2.min && categoriaFilho2.min.value
                  ? categoriaFilho2.min.value
                  : null,
              valor_maximo:
                categoriaFilho2.max && categoriaFilho2.max.value
                  ? categoriaFilho2.max.value
                  : null,
              descricao: filtroAtributos.attribute,
              label: categoriaFilho2.label ? categoriaFilho2.label : '',
            })

            return setArrayFilters(arrayFiltrosCompleto)
          }

          const categoriaFilho4 = categoriaFilho3.filters
            ? categoriaFilho3.filters.find((cat) => cat.selected)
            : null

          if (!categoriaFilho4) {
            arrayFiltrosCompleto.push({
              ...filtroArray,
              tipo: filtroAtributos.type,
              id_atributo: filtroAtributos.id,
              id_valor_unidade: categoriaFilho3.id
                ? categoriaFilho3.id
                : categoriaFilho3.unityId
                ? categoriaFilho3.unityId
                : '',
              valor_minimo:
                categoriaFilho3.min && categoriaFilho3.min.value
                  ? categoriaFilho3.min.value
                  : null,
              valor_maximo:
                categoriaFilho3.max && categoriaFilho3.max.value
                  ? categoriaFilho3.max.value
                  : null,
              descricao: filtroAtributos.attribute,
              label: categoriaFilho3.label ? categoriaFilho3.label : '',
            })

            return setArrayFilters(arrayFiltrosCompleto)
          }

          arrayFiltrosCompleto.push({
            ...filtroArray,
            tipo: filtroAtributos.type,
            id_atributo: filtroAtributos.id,
            id_valor_unidade: categoriaFilho4.id
              ? categoriaFilho4.id
              : categoriaFilho4.unityId
              ? categoriaFilho4.unityId
              : '',
            valor_minimo:
              categoriaFilho4.min && categoriaFilho4.min.value
                ? categoriaFilho4.min.value
                : null,
            valor_maximo:
              categoriaFilho4.max && categoriaFilho4.max.value
                ? categoriaFilho4.max.value
                : null,
            descricao: filtroAtributos.attribute,
            label: categoriaFilho4.label ? categoriaFilho4.label : '',
          })

          return setArrayFilters(arrayFiltrosCompleto)
        }

        return setArrayFilters(arrayFiltrosCompleto)
      }
    })

    return setArrayFilters(arrayFiltrosCompleto)
  }
}
